<vi-page [sidenavs]="true" [footer]="true">
  <vi-content body [centered]="true">
    <div
      main
      class="flex flex-col gap-[24px] sm:gap-[12px] justify-start items-center max-w-[90vw]"
    >
      <ng-container
        *ngIf="
          (authStore.isEndUser$ | async) && (remoteConfigStore.blockEndCustomers$ | async);
          else isNotEndUser
        "
      >
        <img
          class="end-user"
          data-at-end-user-access-forbidden
          src="/assets/img/installer-error.svg"
        />
        <h1>{{ 'ACCESS_FORBIDDEN_PAGE.END_USER.HEADER' | translate }}</h1>
        <p class="end-user-message">{{ 'ACCESS_FORBIDDEN_PAGE.END_USER.CONTENT' | translate }}</p>
        <p class="end-user-footer">{{ 'ACCESS_FORBIDDEN_PAGE.END_USER.FOOTER' | translate }}</p>
      </ng-container>
      <ng-template #isNotEndUser>
        <img data-at-empty-image src="/assets/img/error-403.png" />
        <ng-container *ngIf="authStore.isLiteAccount$ | async; else isNotLiteAccount">
          <h1>{{ 'ACCESS_FORBIDDEN_PAGE.HEADER' | translate }}</h1>
          <p>{{ 'ACCESS_FORBIDDEN_PAGE.LITE_ACCOUNT.CONTENT_1' | translate }}</p>
          <p>{{ 'ACCESS_FORBIDDEN_PAGE.LITE_ACCOUNT.CONTENT_2' | translate }}</p>
          <p>{{ 'ACCESS_FORBIDDEN_PAGE.LITE_ACCOUNT.CONTENT_3' | translate }}</p>
        </ng-container>
        <ng-template #isNotLiteAccount>
          <h1>{{ 'ACCESS_FORBIDDEN_PAGE.HEADER' | translate }}</h1>
          <p>{{ 'ACCESS_FORBIDDEN_PAGE.CONTENT' | translate }}</p>
        </ng-template>
      </ng-template>
    </div>
  </vi-content>
  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
